import client from './client';

export default {
  contactUs: data => {
    return client.post('email/contact/us', data).then(res => res.data);
  },
    sellerMessagesMsgDetail: data => {
      return client.get('seller/messages/conversations/detail', { params: data }).then(res => res.data);
    },
    sellerMessagesList: data => {
      return client.get('seller/messages/conversations', { params: data }).then(res => res.data);
    },
    sellerMessagesSend: data => {
      return client.post('seller/messages/send', data).then(res => res.data);
    },
    publisherMessagesList: data => {
      return client.get('publisher/messages/conversations', { params: data }).then(res => res.data);
    },
    publisherMessagesSend: data => {
      return client.post('publisher/messages/send', data).then(res => res.data);
    },
    publisherMessagesMsgDetail: data => {
      return client.get('publisher/messages/conversations/detail', { params: data }).then(res => res.data);
    },
    sellerNotificationsList: data => {
      return client.get('seller/notifications', { params: data }).then(res => res.data);
    },
    sellerNotificationsUnreadCount: data => {
      return client.get('seller/notifications/unread-count', { params: data }).then(res => res.data);
    },
    sellerNotificationsClearAll: data => {
      return client.post('seller/notifications/clear-all', data).then(res => res.data);
    },
    sellerNotificationsMarkAsRead: (id) => {
      return client.post(`seller/notifications/${id}/read`).then(res => res.data);
    },
    sellerNotificationsSettings: data => {
      return client.get('seller/notifications/settings').then(res => res.data);
    },
    changeSellerNotificationsSettings: data => {
      return client.put('seller/notifications/settings', data).then(res => res.data);
    },
    publisherNotificationsList: data => {
      return client.get('publisher/notifications', { params: data }).then(res => res.data);
    },
    publisherNotificationsUnreadCount: data => {
      return client.get('publisher/notifications/unread-count', { params: data }).then(res => res.data);
    },
    publisherNotificationsClearAll: data => {
      return client.post('publisher/notifications/clear-all', data).then(res => res.data);
    },
    publisherNotificationsMarkAsRead: (id) => {
      return client.post(`publisher/notifications/${id}/read`).then(res => res.data);
    },
    publisherNotificationsSettings: data => {
      return client.get('publisher/notifications/settings').then(res => res.data);
    },
    changePublisherNotificationsSettings: data => {
      return client.put('publisher/notifications/settings', data).then(res => res.data);
    }
   
}
